import { render, staticRenderFns } from "./PaymentRegulation.vue?vue&type=template&id=6cf5b532&scoped=true&"
import script from "./PaymentRegulation.vue?vue&type=script&lang=js&"
export * from "./PaymentRegulation.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRegulation.vue?vue&type=style&index=0&id=6cf5b532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf5b532",
  null
  
)

export default component.exports